import {NgModule} from '@angular/core';
import {
  BaseTableComponent,
  DebounceKeyupDirective,
  DebounceValuechangeDirective,
  DropDownListFilterComponent,
  DropDownListMenuFilterComponent,
  DurationAtomComponent,
  DurationPickerComponent,
  ImperialLengthPipe,
  KendoDropDownSearchableComponent,
  LengthEditorComponent as FramewerxLengthEditorComponent,
  ObjectItemByValuePipe,
  ReactiveGroupBaseTableComponent,
  TimeWrapperComponent as FramewerxTimeWrapperComponent,
} from '@framewerx/kendo-angular-grid';

const FRAMEWERX_KENDO_IMPORTS = [
  BaseTableComponent,
  DebounceKeyupDirective,
  DebounceValuechangeDirective,
  DropDownListFilterComponent,
  DropDownListMenuFilterComponent,
  DurationAtomComponent,
  DurationPickerComponent,
  ImperialLengthPipe,
  KendoDropDownSearchableComponent,
  FramewerxLengthEditorComponent,
  ObjectItemByValuePipe,
  ReactiveGroupBaseTableComponent,
  FramewerxTimeWrapperComponent,
];

@NgModule({
  imports: FRAMEWERX_KENDO_IMPORTS,
  exports: FRAMEWERX_KENDO_IMPORTS,
})
export class FramewerxKendoAngularGridCompatModule {
}
